import { observable, action } from 'mobx';

class AppStore {
    @observable initializing = true;
    @observable error = null;

    @action
    setError(error) {
        this.error = error;
    }

    @action
    setInitialized() {
        this.initializing = false;
    }

}

const appStore = new AppStore();
export { appStore };


// WEBPACK FOOTER //
// ./src/stores/appStore.js